var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('pinjaman-desktop'):_c('pinjaman-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }